module.exports = __webpack_public_path__ + "fonts/Sarabun-ExtraLightItalic.b0669219.ttf";